import Grid from '@material-ui/core/Grid';

// base grid is good enough for now
// change later if needed?
export default Grid;
